// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3xnN0","content":"Consent_content__lfaDe","footer":"Consent_footer__o5rR0"};